import React from 'react'

const User = () => {
  return (
    <div>
      <h2>name:dhruva</h2>
    </div>
  )
}

export default User
